
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { Database } from '@/lib/database.types';

// Default fallback values
const defaultUrl = "https://ruaqbajdaoszmmxlchrw.supabase.co";
const defaultKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ1YXFiYWpkYW9zem1teGxjaHJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUzOTgyMTYsImV4cCI6MjA2MDk3NDIxNn0.YZ27kXgzUEgODYPfaoBvuHnFiq4E2Q9pQTf-rujte0g";

// Get Supabase URL and key from environment variables
// Using exact variable names from Cloudflare Pages
let url = defaultUrl;
let key = defaultKey;

if (typeof import.meta !== 'undefined' && import.meta.env) {
  // From your Cloudflare Pages screenshot, these are the variable names set
  url = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL || defaultUrl;
  key = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.SUPABASE_KEY || defaultKey;
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(url, key);
